
//   function initSignupPopup(container) {
//     const popup = container.querySelector(
//       '[data-newsletter-popup]'
//     );

//     if (!popup) return;

//     // Prevent duplicate initialization
//     if (popup.dataset.popupInitialized === 'true') {
//       return;
//     }

//     popup.dataset.popupInitialized = 'true';

//     const isThemeEditor =
//       window.Shopify &&
//       window.Shopify.designMode === true;

//     /*
//      * Theme Editor preview
//      */
//     if (isThemeEditor) {
//       const isEnabled =
//         {{ section.settings.enable_popup | json }};

//       popup.classList.toggle(
//         'is-active',
//         isEnabled
//       );

//       popup.setAttribute(
//         'aria-hidden',
//         isEnabled ? 'false' : 'true'
//       );

//       return;
//     }

//     const storageKey = 'newsletter_popup_closed';

//     /*
//      * Safe localStorage helpers
//      */
//     function getStorage(key) {
//       try {
//         return localStorage.getItem(key);
//       } catch (error) {
//         console.warn(
//           'localStorage unavailable:',
//           error
//         );
//         return null;
//       }
//     }

//     function setStorage(key, value) {
//       try {
//         localStorage.setItem(key, value);
//       } catch (error) {
//         console.warn(
//           'localStorage unavailable:',
//           error
//         );
//       }
//     }

//     /*
//      * Don't show after customer closes popup
//      */
//     if (getStorage(storageKey)) {
//       return;
//     }

//     const delay =
//       {{ section.settings.popup_delay | default: 3 | json }} * 1000;

//     /*
//      * Show popup
//      */
//     const popupTimer = setTimeout(function () {
//       popup.classList.add('is-active');

//       popup.setAttribute(
//         'aria-hidden',
//         'false'
//       );
//     }, delay);

//     /*
//      * Close popup
//      */
//     const closeBtn = popup.querySelector(
//       '.newsletter-popup-close'
//     );

//     if (closeBtn) {
//       closeBtn.addEventListener('click', function () {
//         clearTimeout(popupTimer);

//         popup.classList.remove('is-active');

//         popup.setAttribute(
//           'aria-hidden',
//           'true'
//         );

//         setStorage(
//           storageKey,
//           'true'
//         );
//       });
//     }
//   }

//   function initializeSignupPopup() {
//     initSignupPopup(document);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener(
//       'DOMContentLoaded',
//       initializeSignupPopup
//     );
//   } else {
//     initializeSignupPopup();
//   }

//   document.addEventListener(
//     'shopify:section:load',
//     function (event) {
//       initSignupPopup(event.target);
//     }
//   );



document.addEventListener("click", (event) => {
  const closeButton = event.target.closest(".newsletter-popup-close");

  if (!closeButton) return;

  document.querySelector(".newsletter-popup-overlay.is-active")?.classList.remove("is-active");
});



document.addEventListener("click", (event) => {
  const button = event.target.closest('#contact_form .newsletter-form__button.button');

  if (!button) return;

  localStorage.setItem("subscribed_newsletter", "true");
});

document.addEventListener("click", (event) => {
  const button = event.target.closest('.discount-popup-trigger-group button.discount-popup-trigger');

  if (!button) return;

  // if( localStorage.getItem("subscribed_newsletter") ){
    document.querySelector(".newsletter-popup-overlay")?.classList.add("is-active");
    document.querySelector(".discount-popup-overlay")?.classList.add("is-active");
  // }
});


document.addEventListener("DOMContentLoaded", () => {
    if( localStorage.getItem("subscribed_newsletter") ){
       document.querySelector(".newsletter-popup-overlay")?.remove();
    }else{
        document.querySelector(".discount-popup-overlay")?.remove();
    }
});

document.addEventListener("DOMContentLoaded", () => {
    if( localStorage.getItem("subscribed_newsletter") ){
       if( ! localStorage.getItem("discount_popup_shown") ){
            document.querySelector(".discount-popup-overlay")?.classList.add("is-active");
            localStorage.setItem("discount_popup_shown", "true");
       }
    }
});













//  jQuery(function ($) {
//     function initRelatedSlider() {
//       $('.relatedproduct-section').each(function () {
//         var $slider = $(this);

//         if ($slider.hasClass('swiper-initialized')) return;

//         var slidesMobile = parseFloat($slider.data('slides-mobile')) || 2.5;
//         var slidesDesktop = ($slider.data('slides-desktop')) || 3;

//         var spaceMobile = ($slider.data('space-mobile')) || 10;
//         var spaceDesktop = ($slider.data('space-desktop')) || 24;

//         new Swiper($slider.find('.complementary-slide')[0], {
//           slidesPerView: slidesMobile,
//           spaceBetween: spaceMobile,
//           loop: true,

//           navigation: {
//             nextEl: '.slider-button--next',
//           prevEl: '.slider-button-prev',
//           },

//           breakpoints: {
//             1024: {
//               slidesPerView: slidesDesktop,
//               spaceBetween: spaceDesktop,
//             },
//           },
//         });
//       });

//       $('body.product product-recommendations').addClass('activeee');
//     }

//     /* Shopify loads recommendations via AJAX */
//     var retry = setInterval(function () {
//       if ($('.relatedproduct-section').length) {
//         initRelatedSlider();
//         // clearInterval(retry);
//       }
//     }, 1000);
//   });